import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { FC, useMemo, useState } from "react";

type CompanyRequestsTableMessageCellProps = {
message: string;
}

const CompanyRequestsTableMessageCell: FC<CompanyRequestsTableMessageCellProps> = ({message}) => {
  const [seeFullMessage, setSeeFullMessage] = useState<boolean>(false);
  const shouldSliceMessage = useMemo<boolean>(() => message.length > 15, [message]);

  return (seeFullMessage || !shouldSliceMessage) ? (
    <span>
      {message}
      {shouldSliceMessage && (
        <IconButton
          title="Minimizar"
          onClick={() => {
            setSeeFullMessage(false);
          }}
        >
          <VisibilityOff />
        </IconButton>
      )}
    </span>
  ) : (
    <span>
      {message.slice(0, 15)}...
      <IconButton
        title="Ver Restante"
        onClick={() => {
          setSeeFullMessage(true);
        }}
      >
        <Visibility />
      </IconButton>
    </span>
  )
}

export default CompanyRequestsTableMessageCell;
